import { putMilestone, globalPut } from '../index';

export const editMilestone = (data) => {
  return putMilestone( data );
};

export const updateKanban = (data) => {
  return globalPut('/milestones/update-kanban', data);
};
